export default {
  /**
   * Determines if the passed window object is an iframe
   * @param {Object} window The window object to assess
   * @return {Boolean}
   */
  active(window) {
    return window.self !== window.top;
  },

  /**
   * Returns the parent window if in an iframe, or the passed window if not
   * @param {Object} window The window object to assess
   * @return {Object}
   */
  getRoot(window) {
    if (this.active(window)) {
      return window.top;
    }

    return window;
  }
};
